import PageContent from "../PageContent/PageContent";
import { useEffect } from "react";
import InfoCover from "../PageContent/PageCovers/InfoCover";

import WelcomeCover from "../PageContent/PageCovers/WelcomeCover";
import PropShow from "../PageContent/PropShow";
import BrancoAnim from "../PageContent/BrancoAnim";
import VideoAsk from "../PageContent/VideoAsk";
import Two from "../PageContent/Two";
import Fancy from "../PageContent/Fancy";
import PinkForm from "../PageContent/PinkForm";
import QuestionBox from "../PageContent/QuestionBox";
import Footer from "../PageContent/Footer";
import CTAButton from "../PageContent/CTAButton";
import Map from "../PageContent/MapPart";
import Testimonial from "../PageContent/Testimonial";
import Marquee from "../PageContent/Marquee";
import FullPagePicture from "../PageContent/FullPagePicture";
import ExplorePair from "../PageContent/ExplorePair";
import PagePart from "../PageContent/PagesPart";

const questionBoxData = {
  title: "Natuurlijk wil u heel goed geïnformeerd zijn!",
  text: [
    "Goed geïnformeerd zijn is het halve werk!",
    "Bekijk dan zeker ook de volgende",
    "Alles Weten pagina.",
  ],
  button: "Vragen? Wij staan voor u klaar!",
};

function Welcome({ page, title, text }) {
  useEffect(() => {
    document.title = title ? title : page;
  }, [title, page]);

  return (
    <div className="content-ctnr">
      <WelcomeCover page={page} text={text} />
      <BrancoAnim page={page} text={text} />
      <Marquee {...{ page, text }} />
      <FullPagePicture />
      <ExplorePair {...{ page, text }} />
      <PagePart />
      <br />
      <br />
      <br />
      <Footer page={page} text={text} />

      <CTAButton page={page} />
    </div>
  );
}

export default Welcome;
